import { View, Text, StyleSheet } from 'react-native';

const DUEL_BLUE = '#3B82F6';
const DUEL_RED = '#EF4444';

interface ActivityEntry {
  exercise_name: string;
  performed_at: string;
  exercise_count: number;
  user_id: string;
}

interface DuelLiftFeedProps {
  activities: ActivityEntry[];
  currentUserId: string;
  challengerId: string;
  challengerName: string;
  challengedName: string;
}

export default function DuelLiftFeed({
  activities,
  currentUserId,
  challengerId,
  challengerName,
  challengedName,
}: DuelLiftFeedProps) {
  if (activities.length === 0) return null;

  return (
    <View style={styles.activitySection}>
      <Text style={styles.activityTitle}>LIVE ACTIVITY</Text>
      {activities.slice(0, 3).map((act, i) => {
        const isYou = act.user_id === currentUserId;
        const who = isYou ? 'You' : (act.user_id === challengerId ? challengerName : challengedName);
        const ago = Math.max(0, Math.round((Date.now() - new Date(act.performed_at).getTime()) / 60000));
        const timeLabel = ago < 1 ? 'just now' : ago < 60 ? `${ago}m ago` : `${Math.floor(ago / 60)}h ago`;
        return (
          <View key={`act-${i}`} style={styles.activityRow}>
            <Text style={[styles.activityWho, { color: isYou ? DUEL_BLUE : DUEL_RED }]}>
              {who}
            </Text>
            <Text style={[styles.activityWhat, { color: '#E8E4DB' }]} numberOfLines={1}>
              {act.exercise_name}{act.exercise_count > 1 ? ` +${act.exercise_count - 1}` : ''}
            </Text>
            <Text style={styles.activityTime}>{timeLabel}</Text>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  activitySection: {
    gap: 4,
    borderTopWidth: 1,
    borderTopColor: '#1A1A1A',
    paddingTop: 10,
  },
  activityTitle: {
    fontSize: 11,
    fontFamily: 'Oswald_700Bold',
    letterSpacing: 2,
    color: '#7A776E',
  },
  activityRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 3,
  },
  activityWho: {
    fontSize: 12,
    fontFamily: 'BarlowCondensed_700Bold',
    width: 55,
    letterSpacing: 0.5,
  },
  activityWhat: {
    fontSize: 12,
    fontFamily: 'Inter_500Medium',
    flex: 1,
  },
  activityTime: {
    fontSize: 11,
    fontFamily: 'Inter_400Regular',
    color: '#4A4840',
  },
});
